import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Send } from "lucide-react";

export function ChatFooter({
  input,
  loading,
  onInput,
  onSend
}: {
  input: string;
  loading: boolean;
  onInput: (v: string) => void;
  onSend: () => Promise<void>;
}) {
  return (
    <footer className="safe-area-bottom border-t border-border p-3">
      <div className="flex items-end gap-2">
        <Textarea
          placeholder="Message the room…"
          value={input}
          disabled={loading}
          onChange={(e) => onInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              void onSend();
            }
          }}
          className="min-h-[44px] resize-none bg-muted"
          rows={2}
        />
        <Button aria-label={loading ? "Sending message" : "Send message"} onClick={() => void onSend()} disabled={loading || !input.trim()} className="h-11 shrink-0 px-3 sm:px-4">
          {loading ? "..." : <><Send size={16} /><span className="hidden sm:inline">Send</span></>}
        </Button>
      </div>
    </footer>
  );
}